module.exports = __webpack_public_path__ + "31a247952e74964d8384e71247d951d2.pdf";